import React, { useRef, useState, useEffect } from "react";
import {
  MenuItem,
  TextField,
  useMediaQuery,
  Box,
} from "@mui/material";
import { MaterialReactTable } from "material-react-table";
import { AGENT_COLUMNS } from "./agentData";
import {
  useChangeAgentStatusMutation,
  useDeleteAgentMutation,
} from "../../redux/api/agentsApi";
import { toast } from "react-toastify";

const LOCAL_STORAGE_KEY = "agents-hidden-columns";

const agentStatuses = [
  { id: 0, label: "Inactive" },
  { id: 1, label: "Active" },
  { id: 2, label: "Delete" },
];

export default function AgentsTable({ data, isFetching }) {
  const [changeAgentStatus] = useChangeAgentStatusMutation();
  const [deleteAgent] = useDeleteAgentMutation();
  const isMobileScreen = useMediaQuery("(max-width:768px)");
  const tableRef = useRef(null);

  const [columnVisibility, setColumnVisibility] = useState({});

  // 🔹 Load saved column visibility on mount
  useEffect(() => {
    const saved = localStorage.getItem(LOCAL_STORAGE_KEY);
    if (saved) setColumnVisibility(JSON.parse(saved));
  }, []);

  // 🔹 Handle status change via dropdown
  const handleStatusChange = async (value, agents) => {
    if (agents.length === 0)
      return toast.warn("Please select at least one agent");

    if (value === 2) {
      // delete confirmation
      if (window.confirm("Are you sure you want to delete the selected agents?")) {
        for (const agent of agents) {
          await deleteAgent({ agentId: agent.agentId, agencyId: agent.agencyId });
        }
      }
      tableRef.current?.resetRowSelection();
      return;
    }

    // activate or deactivate
    for (const agent of agents) {
      await changeAgentStatus({
        agentId: agent.agentId,
        agencyId: agent.agencyId,
        status: value,
      });
    }

    tableRef.current?.resetRowSelection();
  };

  // 🔹 Reset hidden columns
  const handleResetColumns = () => {
    setColumnVisibility({});
    localStorage.removeItem(LOCAL_STORAGE_KEY);
  };

  return (
    <Box>
      <MaterialReactTable
        key={JSON.stringify(columnVisibility)}
        state={{ isLoading: isFetching }}
        tableInstanceRef={tableRef}
        enableStickyHeader={!isMobileScreen}
        muiTableContainerProps={{
          sx: { maxHeight: isMobileScreen ? "100%" : "calc(100vh - 300px)" },
        }}
        columns={AGENT_COLUMNS}
        data={data ?? []}
        enableRowSelection
        enableDensityToggle={false}
        initialState={{
          density: "compact",
          pagination: { pageSize: 20 },
          columnVisibility,
        }}
        getRowId={(row) => row.agentid}
        onColumnVisibilityChange={(updater) => {
          const updated = updater(columnVisibility);
          localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(updated));
          setColumnVisibility(updated);
        }}
        renderTopToolbarCustomActions={({ table }) => {
          const agents = table
            .getSelectedRowModel()
            .rows.map((row) => ({
              agentId: row.original.agentid,
              agencyId: row.original.agencyid,
            }));

          return (
            <TextField
              select
              variant="outlined"
              size="small"
              label="Action"
              sx={{ minWidth: 150 }}
              value=""
              onChange={(e) =>
                handleStatusChange(Number(e.target.value), agents)
              }
            >
              {agentStatuses.map((status) => (
                <MenuItem key={status.id} value={status.id}>
                  {status.label}
                </MenuItem>
              ))}
              {/* <MenuItem
                onClick={handleResetColumns}
                sx={{ color: "primary.main", fontWeight: 500 }}
              >
                Reset Columns
              </MenuItem> */}
            </TextField>
          );
        }}
      />
    </Box>
  );
}
